import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";

class WildAppResource extends AppResource {

}

export default WildAppResource;
